import React, { PureComponent } from "react";
import styled, { keyframes } from "styled-components";

import buildColor from "../ColorPalette";

const pulseAnimation = keyframes`
  0% {
    fill: ${buildColor("white", "50")};
  }
  
  50% {
    fill: ${buildColor("white", "80")};
  }
  
  100% {
    fill: ${buildColor("white", "50")};
  }
`;

const SVG = styled.svg`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 54px;

  rect.pulse {
    animation: ${pulseAnimation} 1.25s infinite;
  }

  rect:last-of-type {
    align-self: center;
  }
`;

export default class RegistrationHeaderMask extends PureComponent {
  render() {
    return (
      <div data-qa-label="registrationBodyMask">
        <SVG>
          <rect
            className="pulse"
            width="100%"
            height="24"
            rx="2"
            fillOpacity="0.6"
          />
          <rect
            className="pulse"
            y="31"
            x="35"
            width="80%"
            height="24"
            rx="2"
            fillOpacity="0.6"
          />
        </SVG>
      </div>
    );
  }
}
